import { FC, PropsWithChildren } from 'react';

import { AdminApiInterceptions } from '../injections/AdminApiInterceptions';
import QueryParam from '../injections/QueryParam';

/**
 * Композиция для закрытой части админки
 * @param root0 Пропсы
 * @param root0.children Дочерние элементы
 */
export const AdminComposition: FC<PropsWithChildren> = ({ children }) => {
  return (
    <AdminApiInterceptions>
      <QueryParam>{children}</QueryParam>
    </AdminApiInterceptions>
  );
};
